import {
  API2_HOST as _API2_HOST,
  replaceContentDomain as replaceContentDomainByBfe,
  TOKEN_COOKIE_KEY,
} from '@bfe/by-dynamic-domain';
import { RUNTIME_ENV } from '@bfe/by-env';

import { REGULATED_SITE_HOSTS } from './compliance';

export const demoAccountAllowPath = [
  '/app/user/api-management',
  '/app/user/add-secret-key',
  '/app/user/edit-secret-key',
];

const DEFAULT_LANG_BY_SITE = {
  HKG: 'zh-HK',
  NLD: 'nl-NL',
  TUR: 'tr-TUR',
  KAZ: 'kk-KAZ',
};

export const DEFAULT_LANG =
  DEFAULT_LANG_BY_SITE[
    REGULATED_SITE_HOSTS as keyof typeof DEFAULT_LANG_BY_SITE
  ] || 'en';

export const replaceContentDomain =
  (typeof window !== 'undefined' && window.replaceContentDomain) ||
  replaceContentDomainByBfe;

export const TG_PLATFORM = {
  pc_tg: 'pc(Telegram)',
  ios_tg: 'iOS(Telegram)',
  android_tg: 'Android(Telegram)',
};

export const WHITE_HOST = [
  'bybit.com',
  'bybit.kz',
  'bybit.eu',
  'bybit.ae',
  'byhkbit.com',
  'bybit-tr.com',
  'bybit.nl',
  'bybit-global.com',
  'bycloud.org',
  'bybits.org',
  'bybitx.global',
  'bybitglobal.com',
  'bytick.com',
  'bybit.cloud',
  'bybit.global',
  'bybit.org',
  'bybitgum.com',
  'bybitgum.org',
  'bybits.io',
  'bybit.biz',
];

export enum VIP_TYPE {
  NoVip = 1,
  Vip = 2,
  Pro = 3,
}

export const API2_HOST =
  (typeof window !== 'undefined' && localStorage.getItem('testApiUrl')) ||
  _API2_HOST;

export const BYBIT_LANG_KEY =
  (typeof window !== 'undefined' && window.BYBIT_LANG_KEY) || 'BYBIT_LANG_KEY';

export const BYBIT_TOKEN_COOKIE_KEY = TOKEN_COOKIE_KEY;

export const BYBIT_GUID_KEY = '_by_l_g_d';

export const I18N_URL_REGEX = /^(?:\/([a-z]{2,3}-[A-Z]{2,3}))?(\/.*)?/;

export const PUBLIC_KEY: any = {
  test: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1unOHX8oH5VoAuwSxju0
rJGz0OzfQoS/kYZsCJImWYvdsc+xo7DiqDWttwURyJBK6Du5zSejvAm6hBM95z3x
xWnl8zDyCNp9QkVnVbpJLBLC7IDsYcfjluqsWj9wi0cHp7XQqZaddTBqXJm5+rqo
2QGasE9aTRgRPpBWvq1Z17Twg8TWpejXBbK+gfxgj0bMdDxMENU9POzBBHWZl7eF
U0y1+rx4gxdReSR/3DUzVbfGkDYmaiUw2a3MTGOulfnDOxWVcj4xJlTBroO11OQd
KE501UGpSRMoST5MmYJPvhhgsOOnPpCVL80uhO5J9VMIacEkHai8d2NtjndzwPEl
mwIDAQAB`,
  testnet: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzqWJC9iJQ836EusWUungoMCwOPKcwRTbSDlAL0eVHKes3fvWcm0vwlDBagUSKke3Wb/VAXBeCX6RMLQakhDCTLVjVGEGHAE5iuQghyFBrH6End94wDGrkzuO23VkEnlVsrDZnMwzPUJHiRQjCmWjkLxEt27a6bPWC5G31LwCz4FotoQ4C4a3rZ24lM75BK8lFJ4MqMv9TDl9TVPNSd8XOEmjRW6XA02lYnX494UaBmQwmOKSS19QL0pyn2MQncQ6zOhZ7D8U7nPmaA7gPJGXYLv9wCqqEh1SRAH5Sv4AwaZIn95iL/Hv2BisSfsUR8u9D8sTkPYa75jlQX4Wbils3QIDAQAB`,
  prod: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6MIsf4XSrrbbOknUrtG9lBkaDB77agL6UzEwB/fUJVD/XFUvhF7LHIoBpfiDcgwlpBIAYL19oHqQ5H+pXqfAI3274rwbtOQt4IhqFre0pFKzT7alA0vJ1y/kXonPIaI4rq3oSSZkNg85eWL5Bc7JcbIyy70UrD12Kpv5LddFAEyRZdnDN7DqfoDndnWjSjwafDHzNYLiACvbWy+lcklXijwEYIPxmUvShqgs6cQAM6hBWTr7QwpNwc48U623PMAIrO6m22+v25YwoByKUWON4QaWReLR9spw781D0myiP50S0fX+sq0O4I3o6lDwHss50oE5uFhQ6JsR3LOzr0ZSuwIDAQAB`,
};

export const getPublicKey = () => {
  console.log('RUNTIME_ENV', RUNTIME_ENV);
  return PUBLIC_KEY[RUNTIME_ENV] || PUBLIC_KEY['prod'];
};

// 浏览器版本过低检测弹窗，过期时间的cookie key，utc0 + 1的时间过期，防止频率过高
export const EXPIRE_TIME_KEY = BYBIT_TOKEN_COOKIE_KEY?.replace(
  'b_t_c_k',
  'detection_time',
);

export const DEFAULT_CAPTCHA_CONFIG = {
  // 邮箱手机号登陆，/login接口
  '31002': {
    completelyUseMagpieCatcha: false,
    useDowngrade: true,
    guidTailList: [],
    // 之前子账号登陆支持的行为验证，没有极验的！！！
    oldCapchaList: ['recaptcha', 'qqcaptcha'],
  },
};
